import {makeAutoObservable} from "mobx";
import {api, calculateLatestVhsDocuments, toSortedVhsEvents, VhsDocInfo} from "../../api";
import {debounce} from "../../utils";
import {VehicleHistoryDto} from "../../api/vhs";

const vinPattern = /^((?![IOQ])[A-Z0-9]){17}$/

interface GetHistoryProps {
    customerId: string
    vin: string
    callback: (history: VehicleHistoryDto) => void
}

const getHistory = debounce(async ({
                                       customerId, vin, callback
                                   }: GetHistoryProps) => {
    const response = await api.vhs.api.getHistory(customerId, vin)
    callback(response.data)
}, 1000)

class VehicleDocumentsStore {
    get data(): VhsDocInfo[] {
        return this._data;
    }

    private set data(value: VhsDocInfo[]) {
        this._data = value;
    }

    get vin(): string | undefined {
        return this._vin;
    }

    private set vin(value: string | undefined) {
        this._vin = value;
    }

    get customerId(): string | undefined {
        return this._customerId;
    }

    private set customerId(value: string | undefined) {
        this._customerId = value;
    }

    get loading(): boolean {
        return this._loading;
    }

    private set loading(value: boolean) {
        this._loading = value;
    }

    private _data: VhsDocInfo[] = []
    private _customerId: string | undefined = undefined
    private _vin: string | undefined = undefined
    private _loading: boolean = false

    constructor(customerId: string | undefined, vin: string | undefined) {
        makeAutoObservable(this)
        this.customerId = customerId
        this.vin = vin
        this.load().finally()
    }

    private async load() {
        this.loading = true
        const {
            customerId,
            vin,
        } = this

        if (vin && customerId && vinPattern.test(vin)) {
            getHistory({
                customerId: customerId,
                vin: vin,
                callback: (data: VehicleHistoryDto)=> {
                    const events = toSortedVhsEvents(data) || []
                    this.data = calculateLatestVhsDocuments(events)
                    this.loading = false
                }
            })
        } else {
            this.data = []
            this.loading = false
        }
    }
}

export {
    VehicleDocumentsStore
}
